const mode = window.location.host.includes("stage")
  ? "STAGE"
  : window.location.host.includes("qa")
  ? "QA"
  : "DEV";

var FILES_URL, API_URL, WEBSITE_LINK;

        if (mode === "STAGE") {
          FILES_URL = "https://apis.uat.quotivo.ai/uploads/";
          API_URL = "https://apis.uat.quotivo.ai/";
          WEBSITE_LINK = "https://quotivo-cbl.quotivo.org/";
        } else if (mode === "QA") {
          FILES_URL = "https://apis.uat.quotivo.ai/uploads/";
          API_URL = "https://apis.uat.quotivo.ai/";
          WEBSITE_LINK = "https://quotivo-cbl.quotivo.org/";
        } else {
          FILES_URL = "https://apis.uat.quotivo.ai/uploads/";
          API_URL = "https://newdevapi.sandbox.quotivo.ai/";
          WEBSITE_LINK = "https://quotivo-cbl.quotivo.org/";
        }

export { FILES_URL, API_URL, WEBSITE_LINK };
